import React from 'react';
import { BaseAlert, BaseAlertProps } from '../BaseAlert';
import { colors } from '../../../settings';
import styled from 'styled-components';
import { IconCaution } from '@99designs/icons';

export const StyledCautionAlert = styled(BaseAlert)`
    background: ${colors.semantic.caution};
    color: white;
`;

type CautionAlertProps = Omit<BaseAlertProps, 'icon'>;

export function CautionAlert({ children, ...rest }: CautionAlertProps) {
    return (
        <StyledCautionAlert icon={<IconCaution />} {...rest}>
            {children}
        </StyledCautionAlert>
    );
}
